import React, { useRef, useEffect, useState } from 'react';
import Slider, { createSliderWithTooltip } from 'rc-slider';
import 'rc-slider/assets/index.css';
import BeatLoader from "react-spinners/BeatLoader";
//import Switch from "react-switch";
import Modal from 'react-modal';

const customStyles = {
    content: {
        top: '15%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
};

Modal.setAppElement('#root')
const AiVideoTags = (props) => {
    const [aiData, setAiData] = useState(props.aiData);
    const [played, setPlayed] = useState(props.played);
    const [videoLabels, setVideoLabels] = useState();
    const [confidenceCutOff, setConfidenceCutOff] = useState(0);
    const [sortByConfidence, setSortByConfidence] = useState();
    const [sortLabelsAlphabeticly, setSortLabelsAlphabeticly] = useState();
    const [selectedArray, setSelectedArray] = useState([]);
    const [labelsOnScreen, setLabelsOnScreen] = useState([]);
    const [timeLineLabels, settimeLineLabels] = useState([]);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [labelsDetailed, setLabelsDetailed] = useState(<></>);

    const [sort1, setSort1] = useState();
    const sliderChange = () => { }
    const updateConfidenceCutoff = () => { }
    const setSortBy = () => { }
    const sortButton = () => { }
    const gotoSingleLabel = () => { }
    const labelDelete = () => { }


    useEffect(() => {
        setVideoLabelTags(buildLabelTags().videoLabelTags)
    }, [selectedArray]
    )

    const openModal = () => {
        setModalIsOpen(true)
    }

    const closeModal = () => {
        setModalIsOpen(false)
    }

    const sec2time = (timeInSeconds) => {
        var pad = function (num, size) { return ('000' + num).slice(size * -1); },
            time = parseFloat(timeInSeconds).toFixed(3),
            hours = Math.floor(time / 60 / 60),
            minutes = Math.floor(time / 60) % 60,
            seconds = Math.floor(time - minutes * 60),
            milliseconds = time.slice(-3);

        return pad(hours, 2) + ':' + pad(minutes, 2) + ':' + pad(seconds, 2) + '.' + pad(milliseconds, 2);
    }



    const labelClicked = (object) => {
        let selected = Array.from(selectedArray)
        let check = selected.includes(object.description)
        let videoDuration = window.player.getDuration()
        let timeLineLabelsLocal = Array.from(timeLineLabels)

        let deleting = false

        let segments = []

        if (!check) {
            let timelineObject = <div className="ems_timeline-tag" id={object.description}>
                {segments}
                <div className="ems_timeline-tag-name">
                    {object.description}
                </div>
            </div>
            timeLineLabelsLocal.push(timelineObject)
            selected.push(object.description)

            object.segments.forEach(segment => {
                let barStart = (segment.startTime / videoDuration) * 100
                let barEnd = (segment.endTime / videoDuration) * 100
                let barWidth = (barEnd - barStart)

                segments.push(
                    <div className="ems_timeline-tag-marker" onClick={gotoSingleLabel.bind(this, (segment.startTime / videoDuration))} id={object.description} style={{ width: `${barWidth}%`, left: `${barStart}%` }}></div>
                )

            })

        } else {
            selected = selected.filter(function (el) { return el != object.description })
            timeLineLabelsLocal = object.description
            deleting = true
            //  labelDelete(object)
        }
        window.addTagToTimeline(timeLineLabelsLocal, deleting)
        setSelectedArray(selected)
        // object.segments.forEach(segment => {
        //     let barStart = (segment.startTime / videoDuration) * 100
        //     let barEnd = (segment.endTime / videoDuration) * 100
        //     let barWidth = (barEnd - barStart)
        //     if (!check) {
        //         segments.push(
        //             <div className="ems_timeline-tag-marker" onClick={gotoSingleLabel.bind(this, (segment.startTime / videoDuration))} id={object.description} style={{ width: `${barWidth}%`, left: `${barStart}%` }}></div>
        //         )
        //     } else {


        //         console.log("already clicked. delete it now")
        //         //selectedArray.push(object.description)

        //     }
        // })

        // if (!check && !deletingLabel) {
        //     let timelineObject = <div className="ems_timeline-tag" id={object.description}>
        //         {segments}
        //         <div className="ems_timeline-tag-name">
        //             {object.description}
        //         </div>
        //     </div>
        //     timeLineLabelsLocal.push(timelineObject)
        //     selectedArray.push(object.description)



        //     //setSelectedArray(selectedArrayLocal)
        //     // this.setState({ timeLineLabels, selectedArray })
        //     // console.log({ timeLineLabelsLocal, selectedArray, selectedArray, timeLineLabels })
        //     //buildLabelTags()
        //     //   let videoLabelTags = buildLabelTags()
        //     //setVideoLabelTags(videoLabelTags)
        // }

        //settimeLineLabels(timeLineLabelsLocal)
        //setVideoLabelTags(buildLabelTags())



    }

    const buildDetailedTags = () => {
        console.log("building detailed labels")
        let labelsDetailed = []

        let videoDuration = window.player.getDuration()


        labelObjects.forEach(object => {
            // console.log({ object })
            let segments = []
            let grids = []




            object.segments.forEach((segment, index) => {
                let barStart = (segment.startTime / videoDuration) * 100
                let barEnd = (segment.endTime / videoDuration) * 100
                let barWidth = (barEnd - barStart)

                segments.push(
                    <div className="ems_timeline-tag-marker" onClick={gotoSingleLabel.bind(this, (segment.startTime / videoDuration))} style={{ width: `${barWidth}%`, left: `${barStart}%` }}>
                    </div>
                )

                grids.push(

                    <div className="ems_grid-item">
                        <div className="ems_item_label"></div>
                    </div>,
                    <div className="ems_grid-item">
                        <div className="ems_item_content">
                            <div className="ems_text ems_time">{sec2time(segment.startTime)}</div>
                        </div>
                    </div>,
                    <div className="ems_grid-item">
                        <div className="ems_item_content">
                            <div className="ems_text ems_time">{sec2time(segment.endTime)}</div>
                        </div>
                    </div>,
                    <div className="ems_grid-item">
                        <div className="ems_item_content">
                            <div className="ems_text ems_time"> {(segment.confidence * 100).toFixed(1)}%</div>
                        </div>
                    </div>

                )
            })

            labelsDetailed.push(
                <div className="ems_group">
                    <div className="ems_inner">
                        <div className="ems_group-item">
                            <div className="ems_grid ems_grid-4">
                                <div className="ems_grid-item ems_grid-item-c4">
                                    <div className="ems_item_label">{object.description}</div>
                                </div>
                                <div className="ems_grid-item ems_grid-item-c4">
                                    <div className="ems_timeline-wrapper">
                                        <div className="ems_timeline-tag">
                                            {segments}
                                        </div>
                                    </div>
                                </div>
                                {grids}
                            </div>
                        </div>
                    </div>
                </div>
            )
        })

        let returnedData =
            <div className="ems_group" style={{ width: "800px" }}>
                <div className="ems_inner">
                    <div className="ems_group-item">
                        <div className="ems_description">Here you can take a look at tags in more detail</div>
                    </div>
                    <div className="ems_group-item">
                        <div className="ems_grid ems_grid-4">
                            <div className="ems_grid-item">
                                <div className="ems_item_label"></div>
                            </div>
                            <div className="ems_grid-item">
                                <div className="ems_item_label">
                                    <div className="ems_text">Start time</div>
                                </div>
                            </div>
                            <div className="ems_grid-item">
                                <div className="ems_item_label">
                                    <div className="ems_text">End time</div>
                                </div>
                            </div>
                            <div className="ems_grid-item">
                                <div className="ems_item_label">
                                    <div className="ems_text">Confidence</div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {labelsDetailed}



                </div>
            </div>



        setLabelsDetailed(returnedData)

        console.log({ returnedData })







    }

    const buildLabelTags = (labelsCurrentlyOnScreen = []) => {
      //  console.log(labelsCurrentlyOnScreen)

        let videoLabelTags = []
        let labelsDetailed = []
        let labelObjects = []
        // console.log( this.state.videoLabels )
        // console.log(this.state.videoLabels.length)
        //console.log({ aiData })
        if (aiData != "nodata" && aiData != "loadingData" && aiData != undefined) {
            aiData.shotLabelAnnotations.forEach(obj => {

                //    console.log({ obj })
                // testData.shotLabelAnnotations.forEach(obj => {
                let object = {
                    segments: [],
                    confidence: 0
                }
                object.description = obj.entity.description

                obj.segments.forEach(segment => {
                    if (segment.confidence > object.confidence) object.confidence = segment.confidence
                    let newSegment = {}
                    if (segment.segment.startTimeOffset.seconds != undefined) {
                        let startTime = parseFloat(`${segment.segment.startTimeOffset.seconds}.${segment.segment.startTimeOffset.nanos}`)
                        newSegment.startTime = startTime

                        object.startTime = startTime
                    } else {
                        newSegment.startTime = 0
                    }

                    newSegment.endTime = `${segment.segment.endTimeOffset.seconds}.${segment.segment.endTimeOffset.nanos}`
                    newSegment.confidence = segment.confidence
                    object.segments.push(newSegment)
                })

                const showing = selectedArray.includes(object.description)


                let className = showing ? 'ems_tag on_timeline' : 'ems_tag';
                //   console.log({ showing, selectedArray, className })
                if (labelsCurrentlyOnScreen.includes(object.description)) {
                    className = "ems_tag on_timeline active"
                }



                if (object.confidence >= confidenceCutOff) {
                    let div

                    if (window.elvisContext.plugin.type === "action") {
                        div = <div className={className} confidenceScore={object.confidence} onClick={labelClicked.bind(this, object)} content={object.description}>
                            {object.description}
                        </div>
                    } else {
                        div = <div className={className} confidenceScore={object.confidence} content={object.description}>
                            {object.description}
                        </div>
                    }

                    labelObjects.push(object)
                    videoLabelTags.push(
                        div
                    )
                }
            })
        }

        if (sortByConfidence) {
            videoLabelTags = videoLabelTags.sort(this.sortLabelsbyConfidenceUp)
        }
        //setLabelObjects(labelObjects)


        return ({ videoLabelTags, labelObjects })


    }

    const updateLabelTags = (labelsCurrentlyOnScreen) => {
        setVideoLabelTags(buildLabelTags(labelsCurrentlyOnScreen).videoLabelTags)
    }

    window.updateLabelTags = updateLabelTags.bind(this)
    const [LabelTags, setVideoLabelTags] = useState(buildLabelTags().videoLabelTags);
    const [labelObjects, setLabelObjects] = useState(buildLabelTags().labelObjects);
    return (
        <div className="ems_tool_group-content-item">
            <div className="ems_tool_module" toolmodule="transcription">
                <div className="ems_tool_group-content-item">
                    <div className="ems_item_label">Video Tags</div>
                    <div className="ems_item_content">
                        {LabelTags}
                    </div>
                    <div className="ems_tool_group-content-item-toolset" id="ems_inline_toolset-items3">
                        <div className="ems_icon ems_icon_settings" onclick="toggleClass('ems_inline_toolset-items3','is-open')"></div>
                        <div className="ems_icon ems_icon_more" onClick={openModal.bind(this)}>
                        </div>
                        <div className="ems_tool_group-content-item-toolset-items">
                            <div className="ems_toolset-item" tooltype="toggle">
                                <label className="ems_toolset-item-label" for="showTimelineTags0">Show
                                    on timeline</label>
                                <div className="ems_toolset-item-content">
                                    <div className="ems_icon ems_icon_toggle" id="toggle3" onclick="toggleClass('toggle3','ems_active')"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                isOpen={modalIsOpen}
                onAfterOpen={buildDetailedTags.bind(this)}
                //onRequestClose={this.closeModa()}
                style={customStyles}
                contentLabel="Example Modal"
            >
                <h2>Hello</h2>
                <button onClick={closeModal.bind(this)}>close</button>
                <div>{labelsDetailed}</div>

            </Modal>
        </div>
    );

};

export default AiVideoTags;

